import { reactive } from 'vue'

// Create a reactive state object
const state = reactive({
    groupsShowingOriginal: {},
    translationEnabled: false,
    selectedLanguage: null,
})

// Export store functions
export function useTranslationStore() {
    /**
     * Toggle original/translation display for a message group
     * @param groupId The ID of the message group (first message ID in the group)
     */
    function toggleMessageGroupTranslation(groupId) {
        state.groupsShowingOriginal[groupId] =
            !state.groupsShowingOriginal[groupId]
    }

    /**
     * Check if a message group is showing original text
     * @param groupId The ID of the message group
     * @returns boolean indicating if original text is showing
     */
    function isGroupShowingOriginal(groupId) {
        // If translations are disabled globally, always show original
        if (!state.translationEnabled) {
            return true
        }
        return !!state.groupsShowingOriginal[groupId]
    }

    /**
     * Reset all translation states
     */
    function resetTranslationState() {
        state.groupsShowingOriginal = {}
    }

    /**
     * Set global translation enabled state
     * @param enabled Whether translations are enabled
     */
    function setTranslationEnabled(enabled) {
        state.translationEnabled = enabled
        // Reset group states when disabling translations
        if (!enabled) {
            resetTranslationState()
        }
    }

    /**
     * Set preferred language
     * @param language The language code
     */
    function setSelectedLanguage(language) {
        state.selectedLanguage = language
    }

    /**
     * Get current global translation enabled state
     */
    function isTranslationEnabled() {
        return state.translationEnabled
    }

    /**
     * Get current selected language
     */
    function getSelectedLanguage() {
        return state.selectedLanguage
    }

    return {
        state,
        toggleMessageGroupTranslation,
        isGroupShowingOriginal,
        resetTranslationState,
        setTranslationEnabled,
        setSelectedLanguage,
        isTranslationEnabled,
        getSelectedLanguage,
    }
}
